package top.wcpe.allincore.dsl.ir.model.hud

import kotlin.jvm.JvmField

/** HUD 自动堆叠策略：同层同组 HUD 按顺序避让。 */
class HudStackPolicy(
    val group: String?,
    direction: String?,
    val gap: Int,
    val order: Int,
) {

    // 保留原 Java 构造语义：direction 为空时回落到 STACK_DOWN，字段恒非空。
    val direction: String = direction ?: HudMetaDefaults.STACK_DOWN

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is HudStackPolicy) return false
        return gap == other.gap &&
            order == other.order &&
            group == other.group &&
            direction == other.direction
    }

    // 逐位复刻 java.util.Objects.hash(group, direction, gap, order)：种子 1、31 倍累乘。
    override fun hashCode(): Int {
        var result = 1
        result = 31 * result + (group?.hashCode() ?: 0)
        result = 31 * result + direction.hashCode()
        result = 31 * result + gap
        result = 31 * result + order
        return result
    }

    override fun toString(): String =
        "HudStackPolicy{" +
            "group='" + group + '\'' +
            ", direction='" + direction + '\'' +
            ", gap=" + gap +
            ", order=" + order +
            '}'

    companion object {
        // @JvmField 使 Java 侧仍以 HudStackPolicy.DEFAULT 静态字段访问。
        @JvmField
        val DEFAULT = HudStackPolicy(null, HudMetaDefaults.STACK_DOWN, 4, 0)
    }
}
